export default __webpack_public_path__ + "static/media/location-icon.001692d6.svg";